module.exports = __webpack_public_path__ + "img/851041d.png";